import { useQuery } from "@tanstack/react-query";
import { fetchSiteInfo } from "../api/siteinfo";
import { SiteInfo } from "../types/site";

/**
 * Shared query definition so code outside a render (e.g. a mutation) can
 * `queryClient.ensureQueryData(siteInfoQueryOptions)` and get the same cached
 * record the header and footer use, instead of guessing when it is not loaded.
 */
export const siteInfoQueryOptions = {
  queryKey: ["site-info"] as const,
  queryFn: async (): Promise<SiteInfo | null> => {
    const response = await fetchSiteInfo();
    return response.data?.[0] ?? null;
  },
  staleTime: 10 * 60 * 1000,
  refetchOnWindowFocus: false,
};

export function useSiteInfo() {
  return useQuery<SiteInfo | null>(siteInfoQueryOptions);
}
